"use client"

import React, { useState, useEffect } from "react"

import { Sidebar } from "../layout/sidebar"

import { Header } from "../layout/header"

import { Footer } from "../layout/footer"

import { useLocation } from "react-router-dom"

import "./globals.css"
import { Toaster } from "../ui/toaster"

interface ClientLayoutProps {

  children: React.ReactNode

}

export default function ClientLayout({ children }: ClientLayoutProps) {

  const [sidebarOpen, setSidebarOpen] = useState(false)

  const location = useLocation()

  const [roleId, setRoleId] = useState<string | null>(null);

  useEffect(() => {
    const storedRoleId = localStorage.getItem("roleId");
    if (storedRoleId) setRoleId(storedRoleId);
  }, []);

  // detect login page (or any auth-only pages)
  const isLoginPage = location.pathname === "/"

  const handleToggleSidebar = () => setSidebarOpen(prev => !prev)

  // If on login page, render children only

  if (isLoginPage) return <>{children}</>

  // For all other pages, render layout with sidebar/header/footer

  return (
    <div

      className={`min-h-screen flex flex-col transition-colors duration-300 bg-gray-50`}
    >
      <Header onSidebarToggle={handleToggleSidebar} />
      <Sidebar isOpen={sidebarOpen} onToggle={handleToggleSidebar} roleId={roleId || "employee"} />
     
      <main

        className={`flex-1 pt-16 transition-all duration-300 ${sidebarOpen ? "lg:ml-64" : ""

          } overflow-x-hidden`}
      >
        <div className="min-h-full flex flex-col w-full max-w-full">{children}</div>
      </main>
      <Footer/>
      <Toaster />
    </div>

  )

}